import React, { useState } from "react";
import { Parallax } from "react-scroll-parallax";
import "./projects.css";
import { Fade } from "react-awesome-reveal";
import { projects } from "./projectsContent";
import { ProjectName } from "./ProjectCard";
import { Link } from "react-router-dom";
import MyProjects from "./MyProjects";

function Projects() {
  const [hoverOnHA, setHoverOnHA] = useState(false);
  const [hoverOnHR, setHoverOnHR] = useState(false);
  const [hoverOnSI, setHoverOnSI] = useState(false);
  const [hoverOnWeather, setHoverOnWeather] = useState(false);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundAttachment: true,
        backgroundRepeat: false,
      }}
    >
      <div className="projectBox">
        <div className="row1 projectRow">
          <Fade>
            <Parallax translateX={["-50%", "5%"]}>
              {/* <div
                className="projectCard"
                onMouseEnter={() => setHoverOnHA(true)}
                onMouseLeave={() => setHoverOnHA(false)}
                style={
                  hoverOnHA
                    ? {
                        border: "#e0e0e0 1.5px solid",
                        borderRadius: "15%",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }
                    : {}
                }
              >
                {hoverOnHA ? (
                  <div
                    style={{
                      paddingTop: 10,
                      transitionDelay: "0.3s",
                      transitionTimingFunction: "ease-in-out",
                    }}
                  >
                    <h1 style={{ color: "white", textAlign: "center" }}>
                      HOME AUTOMATION
                    </h1>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <img
                        style={{
                          width: "20%",
                          textAlign: "center",
                          margin: "auto",
                        }}
                        src="./assets/images/projects/goLive.png"
                        alt=""
                      />
                      <h4 style={{ color: "white", textAlign: "center" }}>
                        Go Live
                      </h4>
                    </div>
                  </div>
                ) : (
                  <img
                    class="projectImg"
                    src="./assets/images/projects/HA.jpg"
                    alt=""
                  />
                )}
              </div> */}
              <Fade className="mb-4">
                <div
                  class="card p-4"
                  style={{
                    maxWidth: "340px",
                    textAlign: "center",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <div class="row g-0 effect-image-1 zoom-effect-1">
                    <div class="col-md-12 project-image-container">
                      <img
                        src={projects[0].src}
                        class="img-fluid rounded-start project-image-home"
                        alt="projectimage"
                      />
                      <div
                        class="overlay-text-effect-3 overlay-text-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "solid green",
                        }}
                      >
                        <p class="card-text">
                          {projects[0].desc}
                          <hr></hr>
                          <a
                            href={projects[0].url}
                            class=""
                            style={{ color: "#fff", textDecoration: "none" }}
                          >
                            Launch Project 🚀
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <ProjectName>{projects[0].name}</ProjectName>
              </Fade>
            </Parallax>
          </Fade>
          <Fade>
            <Parallax translateX={["50%", "5%"]}>
              <Fade className="mb-4">
                <div
                  class="card p-4"
                  style={{
                    maxWidth: "340px",
                    textAlign: "center",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <div class="row g-0 effect-image-1 zoom-effect-1">
                    <div class="col-md-12 project-image-container">
                      <img
                        src={projects[4].src}
                        class="img-fluid rounded-start project-image-home"
                        alt="projectimage"
                      />
                      <div
                        class="overlay-text-effect-3 overlay-text-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "solid green",
                        }}
                      >
                        <p class="card-text">
                          {projects[4].desc}
                          <hr></hr>
                          <a
                            href={projects[4].url}
                            class=""
                            style={{ color: "#fff", textDecoration: "none" }}
                          >
                            Launch Project 🚀
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <ProjectName>{projects[4].name}</ProjectName>
              </Fade>
            </Parallax>
          </Fade>
        </div>
        <div className="row2 projectTitleRow">
          {/* <Parallax translateX={['-300px', '50px']}>
            <div className="projectCard"></div>
          </Parallax> */}
          <Parallax scale={[0.5, 1]}>
            <div className="projectTitle" style={{ borderRadius: "50%" }}>
              <u>
                <h1 style={{ fontSize: "5rem" }}>Projects</h1>
              </u>
              <Link
                to={"/projects"}
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  fontSize: "2rem",
                }}
              >
                Know more about my projects >
              </Link>
            </div>
          </Parallax>
          {/* <Parallax translateX={['300px', '50px']}>
            <div className="projectCard"></div>
          </Parallax> */}
        </div>
        <div className="row3 projectRow">
          {/* <Parallax translateX={['-300px', '50px']}>
            <div className="projectCard"></div>
          </Parallax>
          <Parallax translateX={['300px', '50px']}>
            <div className="projectCard"></div>
          </Parallax> */}
          <Fade>
            <Parallax translateX={["5%", "-50%"]}>
              <Fade className="mb-4">
                <div
                  class="card p-4"
                  style={{
                    maxWidth: "340px",
                    textAlign: "center",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <div class="row g-0 effect-image-1 zoom-effect-1">
                    <div class="col-md-12 project-image-container">
                      <img
                        src={projects[3].src}
                        class="img-fluid rounded-start project-image-home"
                        alt="projectimage"
                      />
                      <div
                        class="overlay-text-effect-3 overlay-text-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "solid green",
                        }}
                      >
                        <p class="card-text">
                          {projects[3].desc}
                          <hr></hr>
                          <a
                            href={projects[3].url}
                            class=""
                            style={{ color: "#fff", textDecoration: "none" }}
                          >
                            Launch Project 🚀
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <ProjectName>{projects[3].name}</ProjectName>
              </Fade>
            </Parallax>
          </Fade>
          <Fade>
            <Parallax translateX={["5%", "50%"]}>
              <Fade className="mb-4">
                <div
                  class="card p-4"
                  style={{
                    maxWidth: "340px",
                    textAlign: "center",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <div class="row g-0 effect-image-1 zoom-effect-1">
                    <div class="col-md-12 project-image-container">
                      <img
                        src={projects[1].src}
                        class="img-fluid rounded-start project-image-home"
                        alt="projectimage"
                      />
                      <div
                        class="overlay-text-effect-3 overlay-text-2"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "solid green",
                        }}
                      >
                        <p class="card-text">
                          {projects[1].desc}
                          <hr></hr>
                          <a
                            href={projects[1].url}
                            class=""
                            style={{ color: "#fff", textDecoration: "none" }}
                          >
                            Launch Project 🚀
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <ProjectName>{projects[1].name}</ProjectName>
              </Fade>
            </Parallax>
          </Fade>
        </div>
      </div>

      <div className="projectBoxInPhone">
        <h1 className="mb-5" style={{ textAlign: "center", color: "white" }}>
          Projects
        </h1>
        <MyProjects />
        <h3 style={{ textAlign: "center" }}>
          <Link
            to={"/projects"}
            style={{
              textDecoration: "none",
              color: "#fff",
              margin: "auto",
            }}
          >
            Know more about my projects >
          </Link>
        </h3>
      </div>
    </div>
  );
}

export default Projects;
